<div class="height-100" fxLayout="column" fxLayoutAlign="center center">
  <mat-progress-spinner mode="indeterminate" color="secondary">
  </mat-progress-spinner>
  <h2>{{ header }}</h2>
  <h3>{{ subheader }}</h3>
</div>
